import { RefCallback } from 'react';
import { Accept } from 'react-dropzone';
import { FileInput, FileInputStyle } from '@ui';
import {
  ATTACHMENT_FILE_SIZE,
  MAX_ATTACHMENT_FILE_SIZE_BYTES,
  MAX_FILES_AMOUNT,
} from '@features/config/files/files.config';
import { FILE_TYPES } from '@features/components/CaseFormBlocks/config';
import { TMDXFile } from '@/api/apis/files';

const OPO_REDACTED_HINT_TEXT = 'This File was uploaded by the OPO and marked as redacted. Please review the document.';

type DocumentsFileInputProps = {
  value: TMDXFile[] | undefined;
  onChange: (files: TMDXFile[]) => void;
  inputRef?: RefCallback<HTMLDivElement>;
  disabled?: boolean;
  maxFiles?: number;
  maxSize?: number;
  accept?: Accept;
  isInvalid?: boolean;
  errorMessage?: string;
  showRedactedBadge?: boolean;
};

export const DocumentsFileInput = ({
  value,
  onChange,
  inputRef,
  disabled,
  maxFiles = MAX_FILES_AMOUNT,
  maxSize = MAX_ATTACHMENT_FILE_SIZE_BYTES,
  accept = FILE_TYPES,
  isInvalid,
  errorMessage,
  showRedactedBadge,
}: DocumentsFileInputProps) => (
  <FileInput
    disabled={disabled}
    files={value ?? []}
    inputRef={inputRef}
    buttonType={FileInputStyle.dashed}
    placeholder={`upload document (${ATTACHMENT_FILE_SIZE.size} ${ATTACHMENT_FILE_SIZE.unit})`}
    multiple
    maxFiles={maxFiles}
    maxSize={maxSize}
    showMaxSize
    accept={accept}
    isInvalid={isInvalid}
    errorMessage={errorMessage}
    showRedactedBadge={showRedactedBadge}
    redactedBadgeHintText={OPO_REDACTED_HINT_TEXT}
    onFilesChange={(newFiles) => {
      if (disabled) return;
      const merged = new Set([...(value ?? []), ...newFiles]);
      onChange(Array.from(merged));
    }}
    onFileDelete={(file) => {
      if (disabled) return;
      onChange((value ?? []).filter((f) => f.id !== file.id));
    }}
  />
);
